import React from 'react';

export default class Amount extends React.Component{

  constructor(props) {
    super(props);

    this.more = this.more.bind(this);
    this.less = this.less.bind(this);
  }

  more() {
    this.props.onChange( Math.min(parseFloat(this.props.value) + parseFloat(this.props.step), parseFloat(this.props.max)) );
  }

  less() {
    this.props.onChange( Math.max(parseFloat(this.props.value) - parseFloat(this.props.step), parseFloat(this.props.min)) );
  }

  render() {
    return (
      <div className="input-group white mb-2 amount">
        <div className="input-group-prepend">
          <button className="btn btn-default" type="button" onClick={this.less}>-</button>
        </div>
        <input type="text" disabled className="form-control text-center" value={this.props.value} />
        <div className="input-group-append">
          <button className="btn btn-default" type="button" onClick={this.more}>+</button>
        </div>
      </div>
    );
  }

}
